import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

const DetalhesCoordenador = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [coordenador, setCoordenador] = useState(null);
  const [cursos, setCursos] = useState([]);
  const [parametros, setParametros] = useState({ cor_cabecalho: "#156082" });

  useEffect(() => {
    carregarCoordenador();
    carregarParametros();
  }, [id]);

  const carregarCoordenador = async () => {
    try {
      const response = await fetch(`/api/usuarios/${id}`);
      const dadosCoordenador = await response.json();

      if (dadosCoordenador.erro) {
        alert("Coordenador não encontrado.");
        navigate("/coordenadores");
      } else {
        setCoordenador(dadosCoordenador);

        const clienteId = localStorage.getItem("cliente_id");
        const resCursos = await fetch(`/api/cursos?cliente_id=${clienteId}&coordenador=${dadosCoordenador.nome_completo}`);
        const listaCursos = await resCursos.json();
        setCursos(listaCursos);
      }
    } catch (error) {
      console.error("Erro ao carregar coordenador:", error);
      alert("Erro ao carregar os dados do coordenador.");
    }
  };

  const carregarParametros = async () => {
    try {
      const clienteId = localStorage.getItem("cliente_id");
      const response = await fetch(`/api/parametros_cliente/${clienteId}`);
      const dados = await response.json();
      if (!dados.erro) {
        setParametros(dados);
      }
    } catch (error) {
      console.error("Erro ao carregar parâmetros do cliente:", error);
    }
  };

  const excluirCoordenador = async () => {
    if (window.confirm("Tem certeza que deseja excluir este coordenador?")) {
      try {
        const usuario_id = localStorage.getItem("user_id");
  
        const response = await fetch(`/api/usuarios/${id}?usuario_id=${usuario_id}`, {
          method: "DELETE",
        });
  
        if (response.ok) {
          alert("Coordenador excluído com sucesso!");
          navigate("/coordenadores");
        } else {
          alert("Erro ao excluir coordenador.");
        }
      } catch (error) {
        console.error("Erro ao excluir coordenador:", error);
        alert("Erro ao excluir coordenador.");
      }
    }
  };
  

  const formatarTelefone = (telefone) => {
    if (!telefone) return "";
    const numeros = telefone.replace(/\D/g, ""); // Remove não numéricos
    if (numeros.length === 11) {
      return `(${numeros.slice(0, 2)}) ${numeros.slice(2, 7)}-${numeros.slice(7)}`;
    } else if (numeros.length === 10) {
      return `(${numeros.slice(0, 2)}) ${numeros.slice(2, 6)}-${numeros.slice(6)}`;
    }
    return telefone;
  };
  


  const formatarDataParaExibicao = (dataISO) => {
    if (!dataISO) return "";
    const partes = dataISO.split("-");
    if (partes.length === 3) {
      return `${partes[2]}-${partes[1]}-${partes[0]}`;
    }
    return dataISO;
  };

  if (!coordenador) return <div>Carregando...</div>;

  return (
    <div className="form-wrapper form-coordenador">
      <h2 className="form-title">Detalhes do Coordenador</h2>

      {/* Dados Pessoais */}
      <div className="linha-horizontal">
        
        <div className="coluna" style={{ flex: 1 }}>
          <label><strong>Nome Completo</strong></label>
          <span>{coordenador.nome_completo || "-"}</span>
        </div>
        <div className="coluna" style={{ width: "200px" }}>
          <label><strong>CPF</strong></label>
          <span>{coordenador.cpf || "-"}</span>
        </div>
      </div>

      <div className="linha-horizontal">
        <div className="coluna" style={{ width: "220px" }}>
          <label><strong>Gênero</strong></label>
          <span>{coordenador.genero || "-"}</span>
        </div>
        <div className="coluna" style={{ width: "200px" }}>
          <label><strong>Data de Nascimento</strong></label>
          <span>{formatarDataParaExibicao(coordenador.data_nascimento)}</span>
        </div>
        <div className="coluna" style={{ flex: 1 }}>
          <label><strong>Cargo</strong></label>
          <span>{coordenador.cargo || "-"}</span>
        </div>
      </div>

      <div className="form-row">
  <div className="form-group" style={{ width: "220px", flex: "none" }}>
    <label>Telefone</label>
    <div className="campo-detalhe">{formatarTelefone(coordenador.telefone) || "-"}</div>
  </div>

  <div className="form-group" style={{ width: "300px", flex: "none" }}>
    <label>E-mail</label>
    <div className="campo-detalhe">
      {coordenador.email ? (
        <a href={`mailto:${coordenador.email}`} target="_blank" rel="noopener noreferrer">
          {coordenador.email}
        </a>
      ) : (
        "-"
      )}
    </div>
  </div>

  <div className="form-group">
    <label>Usuário</label>
    <div className="campo-detalhe">{coordenador.usuario || "-"}</div>
  </div>
</div>


      {/* Cursos vinculados */}
      <h3 className="subtitulo">Cursos Vinculados</h3>

      {cursos.length > 0 ? (
        <div style={{ overflowX: "auto", marginTop: "10px" }}>
          <table className="tabela" style={{ fontSize: "0.75rem", marginTop: "10px" }}>
            <thead
              style={{
                backgroundColor: parametros?.cor_cabecalho || "#156082",
                color: "white"
              }}
            >
              <tr>
                <th style={{ width: "20%", textAlign: "left", padding: "10px" }}>Código</th>
                <th style={{ width: "40%", textAlign: "left", padding: "10px" }}>Nome</th>
                <th style={{ width: "20%", textAlign: "left", padding: "10px" }}>Nível</th>
                <th style={{ width: "20%", textAlign: "left", padding: "10px" }}>Modalidade</th>
              </tr>
            </thead>
            <tbody>
              {cursos.map((curso) => (
                <tr key={curso.id}>
                  <td style={{ padding: "10px" }}>{curso.codigo}</td>
                  <td style={{ padding: "10px" }}>{curso.nome}</td>
                  <td style={{ padding: "10px" }}>{curso.nivel}</td>
                  <td style={{ padding: "10px" }}>{curso.modalidade}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p style={{ marginTop: "10px" }}>Nenhum curso vinculado.</p>
      )}

      {/* Botões */}
      <div className="form-actions">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => navigate("/coordenadores")}
        >
          Voltar
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => navigate(`/coordenadores/editar/${coordenador.id}`)}
        >
          Editar
        </button>
        <button
          type="button"
          className="btn btn-danger"
          onClick={excluirCoordenador}
        >
          Excluir
        </button>
      </div>
    </div>
  );
};

export default DetalhesCoordenador;


